import { useCallback } from 'react'

export function useScrollTop(flag) {
  if (!flag) {
    throw new Error('className or id of target element should not be empty')
  }

  const getNode = useCallback(() => {
    let node = null
    if (window) {
      if (flag.startsWith('#')) {
        node = document.getElementById(flag.slice(1))
      } else {
        node = document.querySelector(`.${flag}`)
      }
    }
    return node
  }, [flag])

  const setScrollTop = useCallback(() => {
    const node = getNode()
    if (window && node) {
      window.localStorage.setItem(`${flag}-scroll-top-number`, node.scrollTop || 0)
    }
  }, [flag, getNode])

  const initScrollTop = useCallback(() => {
    const node = getNode()
    if (window && node) {
      const top = window.localStorage.getItem(`${flag}-scroll-top-number`) || 0
      node.scrollTop = top
    }
  }, [flag, getNode])

  const clearScrollTop = useCallback(() => {
    const node = getNode()
    if (window && node) {
      window.localStorage.setItem(`${flag}-scroll-top-number`, 0)
    }
  }, [flag, getNode])

  return {
    initScrollTop,
    setScrollTop,
    clearScrollTop,
  }
}
